import { Tooltip } from 'floating-vue';

export default {
  props: {
    content: {
      type: String,
    },
  },

  components: {
    Tooltip,
  },

  mounted() {},

  data() {
    return {};
  },

  computed: {},

  methods: {
    onHideClick() {
      this.$refs.tooltip.hide();
    },
  },

  watch: {},
};
